import { ITask } from "./ITask"
import { ITaskParent } from "./ITaskParent"
import { ITaskSearcher } from "./ITaskSearcher"


export class task_api {
    public static save:string = "/api/task/save"
    public static del_task:string = "/api/task/del_task"
    public static get_task:string = "/api/task/get_task"
    public static find:string = "/api/task/find"
    public static fill_parent:string = "/api/task/fill_parent"

}

export interface ITaskServer {
    save(task: ITask): Promise<ITask|undefined> 
    fill_parent(task: ITask): Promise<ITask|undefined> 
    find(parent: ITaskSearcher): Promise<ITask[]> 
}